import { useSelector } from "react-redux";
import { isAuthorized, moduleAuthorized } from "cfgCommon/authorization";

const isFeature = (acronym) =>{
  return acronym.includes('_')
}

const returnPermission = (acronym,permissions) =>{
  if(acronym==="HAS_ANY"){
    return permissions?.Active_modules?.length>0
  }
  if(isFeature(acronym)){
    return isAuthorized({
      functions: permissions?.Active_functions,
      feature: acronym
    })
  }else{
    return moduleAuthorized({
      functions: permissions?.Active_modules,
      feature: acronym
    })
  }
}


const useCheckPermission = (acronym) => {
  const permissions = useSelector(state => state.common.user.permissions)
  return returnPermission(acronym, permissions)
}
 
export default useCheckPermission;

//This version is for class components, they need to check redux's state themselves and pass it to the function
export const checkPermission = (acronym, permissions) =>{
  return returnPermission(acronym, permissions)
}